import { DateRangeOption } from '../../legacy-design-system/date-picker'
import { theme } from '../../styled'
import * as Highcharts from 'highcharts'

export { VulnsDiscoveryChart } from './discovery-chart'
export { VulnsOpenClosedChart } from './open-closed-chart'
export { VulnsSeverityChart } from './severity-chart'
export * from './utils-timeline'

export function bold(msg) {
  return `<b>${msg[0]}</b>`
}

export const dateFormatConfig: Record<DateRangeOption, string> = {
  [DateRangeOption.LAST_DAY]: '%H:%M',
  [DateRangeOption.LAST_7_DAYS]: '%A %m/%d',
  [DateRangeOption.LAST_30_DAYS]: '%m/%d',
  [DateRangeOption.LAST_12_MONTHS]: '%m/%d',
  [DateRangeOption.CUSTOM]: ''
}

export const xAxisMaxPadding: number = 0.04
export const xAxisMinPadding: number = 0.04

export const yAxisBaseConfig: Highcharts.YAxisOptions = {
  allowDecimals: false,
  tickAmount: 5,
  labels: {
    align: 'center',
    useHTML: true,
    style: {
      color: theme.colors.gray005,
      fontWeight: theme.fontWeights.primary.medium.toString(),
      fontFamily: theme.fontFamilies.primaryCondensed,
      fontSize: '11px',
      minWidth: '24px',
      textAlign: 'right'
    }
  }
}
